<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <p class="copyright-title">Copyright 2022-2025, 版权所有：广州云之智科技有限公司</p>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less" scoped>
.copyright-title {
  position: fixed;
  line-height: 30px;
  text-align: center;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: auto;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue